import { ThemeToggle } from './ThemeToggle.jsx';
import { CampLogo } from './CampLogo.jsx';
import { useAuth } from '../lib/auth.jsx';

const ROLE_TH = { admin: 'แอดมิน', manager: 'ผู้จัดการ', staff: 'พนักงาน' };
// Trial link: only let it toggle ผู้จัดการ ↔ พนักงาน — never admin.
// (To preview admin during dev: localStorage.setItem('hr-demo-role','admin'))
const ROLE_CYCLE = { manager: 'staff', staff: 'manager', admin: 'manager' };

export function StatusBar() {
  const { isDemo, demoRole, changeDemoRole } = useAuth();
  return (
    <div className="status">
      <span className="brand">
        <CampLogo height={18} />
        <span className="brand-name">ห้องปกครอง</span>
      </span>
      <span className="right">
        {isDemo && (
          <button className="role-switch" onClick={() => changeDemoRole(ROLE_CYCLE[demoRole] || 'manager')}
            title="สลับมุมมองสิทธิ์ (เฉพาะ demo)">
            {ROLE_TH[demoRole] || demoRole} ⇄
          </button>
        )}
        {isDemo && <span className="demo-badge">DEMO</span>}
        <ThemeToggle />
      </span>
    </div>
  );
}
